// extracted by mini-css-extract-plugin
export var border = "_d-8";
export var brand = "_d-t";
export var button = "_d-l";
export var center = "_d-a";
export var centered = "_d-6";
export var closeButton = "_d-c";
export var disabledWrapper = "_d-m";
export var error = "_d-p";
export var extraLarge = "_d-4";
export var extraSmall = "_d-1";
export var fill = "_d-i";
export var footer = "_d-h";
export var footerAction = "_d-j";
export var footerButtons = "_d-k";
export var header = "_d-7";
export var headerWithClose = "_d-d";
export var icon = "_d-o";
export var info = "_d-s";
export var inline = "_d-9";
export var large = "_d-3";
export var main = "_d-e";
export var modal = "_d-0";
export var nearFull = "_d-5";
export var neutral = "_d-u";
export var noPadding = "_d-g";
export var none = "_d-v";
export var scrollable = "_d-f";
export var small = "_d-2";
export var success = "_d-r";
export var tight = "_d-n";
export var titleIcon = "_d-b";
export var warn = "_d-q";